import { type MutationHookOptions, useMutation } from "@apollo/client";
import { UpdatePlatformPagesMutation } from "../graphql/mutations";
import type {
  UpdatePlatformPagesMutationType,
  UpdatePlatformPagesMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useUpdatePlatformPagesMutation = (
  options?: MutationHookOptions<
    UpdatePlatformPagesMutationType,
    UpdatePlatformPagesMutationVariablesType
  >
) => {
  return useMutation<
    UpdatePlatformPagesMutationType,
    UpdatePlatformPagesMutationVariablesType
  >(UpdatePlatformPagesMutation, options);
};
